import gql from 'graphql-tag';

const CREATE_FRICTIONLESS_PR = gql`
  mutation createFrictionlessPR($data: CreateFrictionlessPRInput!) {
    createFrictionlessPR(data: $data) {
      file {
        name
        path
        size
        content
      }
      prNumber
      prUrl
    }
  }
`;

export default CREATE_FRICTIONLESS_PR;